import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

export const CloseDialogAction = (props: { isProcessing?: boolean, onCancel: () => void }) => {
  const { t } = useTranslation('common');

  return <IconButton disabled={props.isProcessing}
    aria-label={t('close')}
    onClick={props.onCancel}
    sx={{
      color: (theme) => theme.palette.custom.gray[800],
      mr: '-12px',
    }}
  >
    <CloseIcon />
  </IconButton>;
};